var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { AppBar, Toolbar, useTheme, useMediaQuery, Box, Divider, Typography, Button, IconButton, styled, Tooltip, tooltipClasses, Menu, MenuItem, Popover } from '@mui/material';
import './../../assets/scss/dashboard.scss';
import ConfirmationAndInformationPoup, { POPUP_TYPE } from './ConfirmationAndInformationPoup';
import { useDispatch } from 'react-redux';
import { NavigationConfig } from '../../utils/navigation_config';
import { useLocation, useNavigate } from 'react-router-dom';
import LogoutIcon from '@mui/icons-material/Logout';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { loginSignup_asyncActions } from '../../asyncActions/loginSignup_asynActions';
import { useEffect } from 'react';
import i18next from 'i18next';
import '../../assets/scss/appBar.scss';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import constants, { AppStatuses, APPLICATION_TYPES, ReDocsStatus, DocsMissingStatus, DocsRequestedESignatureStatus, DocsRequestedPdfStatus, EDIT_TYPES_ENUMS } from '../../config/constants';
import { user_actions } from '../../actions/user_actions';
import FranceFlag from './../../assets/images/DDicons/france.svg';
import GlobeFlag from '../../assets/images/DDicons/global.svg';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import AuxiliorHorizontalLogo from '../../assets/images/Auxilior-Logo-Horizontal.png';
import { SupportIcon, RateCard, FAQIcon, AnalyticsIcon, GlobeDesignIcon, ChevronDownDesignIcon, NotificationDesignIcon, ProfilePictureIcon, ApplicationSidebarActionNeededIcon, ApplicationSidebarApprovedIcon, ApplicationSidebarBookedIcon, ApplicationSidebarInProgressIcon, ApplicationSidebarOtherApplicationsIcon, ApplicationSidebarSignFinalizeIcon, ApplicationSidebarUnderReviewIcon, MarketingBellIcon } from '../icons';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { getColors } from '../../Themes/default_color';
import { getContrastText } from '../../utils/commonUtilities';
import CountdownTimer from '../../utils/countdownTimer';
import moment from 'moment';
import { api_service } from '../../api/api_service';
import { utility } from '../../utils';
import { api_urls } from '../../api/api_urls';
import { ApplicationsNavIcon, DashboardNavIcon, MoreNavIcon, QuoteToolNavIcon, SentApplicationsNavIcon } from './revampNavIcons';
import NeedHelpDialog from './NeedHelpDialog';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import Fuse from 'fuse.js';
import { globalSearch_actions } from '../../actions/globalSearch_actions';
import AppHeaderSearch from '../FormComponents/AppHeaderSearch';
export var Language;
(function (Language) {
    Language["ENGLISH"] = "en";
    Language["FRENCH"] = "fr";
})(Language || (Language = {}));
const normalizeLanguageCode = (value) => {
    return value === Language.FRENCH ? Language.FRENCH : Language.ENGLISH;
};
const LanguageOptions = [
    { lang: 'English', value: Language.ENGLISH, url: GlobeFlag },
    { lang: 'Français', value: Language.FRENCH, url: FranceFlag }
];
const headerNotificationTabs = [
    { key: 'announcements', label: 'DASHBOARD_HEADER.ANNOUNCEMENTS_UPDATES', isVisible: true },
    { key: 'notifications', label: 'DASHBOARD_HEADER.NOTIFICATIONS', isVisible: false },
];
const DASHBOARD_KPI_STATUSES = new Set([
    AppStatuses.Credit,
    AppStatuses['Credit More Info'],
    AppStatuses.Approved,
    AppStatuses.Documents,
    AppStatuses['Saved Applications'],
    AppStatuses.Booked,
]);
const MARKETING_ROTATION_INTERVAL_MS = 2400;
const MARKETING_FADE_DURATION_MS = 250;
const DISMISSED_BANNER_KEY = 'auxilior_dismissed_banner_ids';
const MarketingBanner = React.memo(React.forwardRef(({ marketingBannerItems, isSuperUser, impersonationDetails, handleSuperUserLogout, }, ref) => {
    const [t] = useTranslation("global");
    const [activeMarketingItemIndex, setActiveMarketingItemIndex] = React.useState(0);
    const [isMarketingMessageVisible, setIsMarketingMessageVisible] = React.useState(true);
    const [isMarketingBannerVisible, setIsMarketingBannerVisible] = React.useState(false);
    useEffect(() => {
        if (marketingBannerItems.length > 0) {
            try {
                const dismissed = JSON.parse(localStorage.getItem(DISMISSED_BANNER_KEY) || '[]');
                const hasNewItems = marketingBannerItems.some((item) => !dismissed.includes(item.id));
                if (hasNewItems) {
                    setIsMarketingBannerVisible(true);
                    setActiveMarketingItemIndex(0);
                    setIsMarketingMessageVisible(true);
                }
            }
            catch (_a) {
                setIsMarketingBannerVisible(true);
                setActiveMarketingItemIndex(0);
                setIsMarketingMessageVisible(true);
            }
        }
    }, [marketingBannerItems]);
    useEffect(() => {
        if (!isMarketingBannerVisible || marketingBannerItems.length <= 1)
            return;
        let fadeTimeout = null;
        const intervalId = setInterval(() => {
            setIsMarketingMessageVisible(false);
            fadeTimeout = setTimeout(() => {
                setActiveMarketingItemIndex((prev) => (prev + 1) % marketingBannerItems.length);
                setIsMarketingMessageVisible(true);
            }, MARKETING_FADE_DURATION_MS);
        }, MARKETING_ROTATION_INTERVAL_MS);
        return () => {
            clearInterval(intervalId);
            if (fadeTimeout)
                clearTimeout(fadeTimeout);
        };
    }, [isMarketingBannerVisible, marketingBannerItems.length]);
    const activeMarketingItem = marketingBannerItems[activeMarketingItemIndex];
    const shouldShowContent = (isMarketingBannerVisible && marketingBannerItems.length > 0) || isSuperUser;
    return (React.createElement(Box, { className: "dashboard-marketing-banner", ref: ref, role: shouldShowContent ? "status" : undefined }, shouldShowContent && (React.createElement(Box, { className: "dashboard-marketing-banner-inner", sx: { minHeight: (isMarketingBannerVisible && marketingBannerItems.length > 0) ? '42px' : '30px' } },
        isMarketingBannerVisible && marketingBannerItems.length > 0 && (React.createElement(Box, { className: "dashboard-marketing-content" },
            React.createElement(Box, { className: "dashboard-marketing-badge-wrap" },
                React.createElement(Typography, { className: "dashboard-marketing-badge" },
                    React.createElement(MarketingBellIcon, null))),
            React.createElement(Box, { className: `dashboard-marketing-text-wrap ${isMarketingMessageVisible ? "" : "is-fading"}` },
                React.createElement(Typography, { className: "dashboard-marketing-text", fontSize: '14px' }, activeMarketingItem === null || activeMarketingItem === void 0 ? void 0 : activeMarketingItem.message)))),
        isSuperUser && (React.createElement(Box, { className: `dashboard-super-user-pill${!(isMarketingBannerVisible && marketingBannerItems.length > 0) ? ' is-centered' : ''}` },
            React.createElement(AccessTimeOutlinedIcon, { sx: { fontSize: 15, color: '#6B7280', flexShrink: 0 } }),
            React.createElement(Typography, { className: "dashboard-super-user-text" }, t("GENERIC_STRINGS.SuperUserBannerMsg")),
            React.createElement(CountdownTimer, { startTimeString: impersonationDetails === null || impersonationDetails === void 0 ? void 0 : impersonationDetails.SessionStartTime, handleLogout: handleSuperUserLogout, timerColor: "#2E75B6" }))),
        isMarketingBannerVisible && marketingBannerItems.length > 1 && (React.createElement(Box, { className: "dashboard-marketing-indicators", "aria-hidden": "true" }, marketingBannerItems.map((item, index) => (React.createElement("span", { key: `${item.id}-${index}`, className: `dashboard-marketing-indicator ${index === activeMarketingItemIndex ? "is-active" : ""}` }))))),
        isMarketingBannerVisible && marketingBannerItems.length > 0 && (React.createElement(IconButton, { size: "small", className: "dashboard-marketing-close", onClick: () => {
                const ids = marketingBannerItems.map((item) => item.id);
                try {
                    localStorage.setItem(DISMISSED_BANNER_KEY, JSON.stringify(ids));
                }
                catch (_a) { }
                setIsMarketingBannerVisible(false);
            }, "aria-label": t("Dashboard.Queue.CloseAnnouncement") },
            React.createElement(CloseOutlinedIcon, { fontSize: "small" })))))));
}));
export default function MuiAppBar() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const colors = getColors();
    const theme = useTheme();
    const isMobileHeader = useMediaQuery(theme.breakpoints.down('md'));
    const headerRowRef = React.useRef(null);
    const headerLeftRef = React.useRef(null);
    const headerRightRef = React.useRef(null);
    const fullTabsMeasureRef = React.useRef(null);
    const tabWidthRefsMap = React.useRef(new Map());
    const [visibleTabKeys, setVisibleTabKeys] = React.useState(null);
    const [selectedLangCode, setSelectedLangCode] = React.useState(Language.ENGLISH);
    const [langMenuAnchorEl, setLangMenuAnchorEl] = React.useState(null);
    const [moreMenuAnchorEl, setMoreMenuAnchorEl] = React.useState(null);
    const [notificationsAnchorEl, setNotificationsAnchorEl] = React.useState(null);
    const [activeNotificationTab, setActiveNotificationTab] = React.useState('announcements');
    const [announcementItems, setAnnouncementItems] = React.useState([]);
    const [isProfileMenuOpen, setIsProfileMenuOpen] = React.useState(false);
    const [openLogoutConfirm, setOpenLogoutConfirm] = React.useState(false);
    const [openQuoteToolUnsavedPopup, setOpenQuoteToolUnsavedPopup] = React.useState(false);
    const [mobileSearchOpen, setMobileSearchOpen] = React.useState(false);
    const [pendingHeaderNavigation, setPendingHeaderNavigation] = React.useState('');
    const pendingSearchCallbackRef = React.useRef(null);
    const globalSearchText = useSelector((state) => state.GlobalSearch.searchText);
    const globalDisplayText = useSelector((state) => state.GlobalSearch.displayText);
    const globalSearchOpen = useSelector((state) => state.GlobalSearch.isOpen);
    const globalSearchActiveTab = useSelector((state) => state.GlobalSearch.activeTab);
    const pendingContractIdSearch = useSelector((state) => state.GlobalSearch.pendingContractIdSearch);
    const setGlobalSearchText = (text) => dispatch(globalSearch_actions.setSearchText(text));
    const setGlobalSearchOpen = (open) => dispatch(globalSearch_actions.setSearchOpen(open));
    const setGlobalSearchActiveTab = (tab) => dispatch(globalSearch_actions.setActiveTab(tab));
    const [globalSearchCategoryOpen, setGlobalSearchCategoryOpen] = React.useState(false);
    const globalSearchRef = React.useRef(null);
    const categoryTriggerRef = React.useRef(null);
    const categoryDropdownRef = React.useRef(null);
    React.useEffect(() => {
        if (!globalSearchCategoryOpen)
            return;
        const handleCategoryOutsideClick = (event) => {
            var _a, _b;
            const target = event.target;
            if ((_a = categoryTriggerRef.current) === null || _a === void 0 ? void 0 : _a.contains(target))
                return;
            if ((_b = categoryDropdownRef.current) === null || _b === void 0 ? void 0 : _b.contains(target))
                return;
            setGlobalSearchCategoryOpen(false);
        };
        document.addEventListener('mousedown', handleCategoryOutsideClick);
        return () => document.removeEventListener('mousedown', handleCategoryOutsideClick);
    }, [globalSearchCategoryOpen]);
    const isSearchActiveNow = globalSearchOpen || Boolean(globalSearchText || globalDisplayText);
    const [searchActive, setSearchActive] = React.useState(isSearchActiveNow);
    React.useEffect(() => {
        if (isSearchActiveNow) {
            setSearchActive(true);
            return;
        }
        const timer = setTimeout(() => setSearchActive(false), 220);
        return () => clearTimeout(timer);
    }, [isSearchActiveNow]);
    React.useLayoutEffect(() => {
        var _a, _b;
        const headerRow = headerRowRef.current;
        const headerLeft = headerLeftRef.current;
        const headerRight = headerRightRef.current;
        const fullTabs = fullTabsMeasureRef.current;
        if (!headerRow || !headerLeft || !headerRight || !fullTabs)
            return;
        const TAB_GAP = 8;
        const recompute = () => {
            var _a;
            const logoEl = headerLeft.querySelector('.revamp-brand-logo');
            const searchEl = globalSearchRef.current;
            const logoWidth = (_a = logoEl === null || logoEl === void 0 ? void 0 : logoEl.getBoundingClientRect().width) !== null && _a !== void 0 ? _a : 0;
            const rightWidth = headerRight.getBoundingClientRect().width;
            const searchTargetWidth = searchActive ? 450 : 250;
            const rowStyle = window.getComputedStyle(headerRow);
            const rowContentWidth = headerRow.getBoundingClientRect().width
                - parseFloat(rowStyle.paddingLeft || '0')
                - parseFloat(rowStyle.paddingRight || '0');
            const LOGO_TO_TABS_GAP = 24;
            const searchMarginLeft = searchEl ? parseFloat(window.getComputedStyle(searchEl).marginLeft || '0') : 0;
            const rightMarginLeft = parseFloat(window.getComputedStyle(headerRight).marginLeft || '0');
            const availableForTabs = rowContentWidth - logoWidth - LOGO_TO_TABS_GAP - searchMarginLeft - searchTargetWidth - rightMarginLeft - rightWidth;
            const contentTabs = headerTabs.filter(tab => !tab.hidden && tab.key !== 'more');
            const activeHeaderTab = getActiveHeaderTab();
            const widthOf = (key) => { var _a, _b; return (_b = (_a = tabWidthRefsMap.current.get(key)) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) !== null && _b !== void 0 ? _b : 0; };
            const fullTabsWidth = fullTabs.scrollWidth;
            let nextVisible;
            if (fullTabsWidth <= availableForTabs) {
                nextVisible = null;
            }
            else {
                let budget = availableForTabs - widthOf('more-collapsed') - TAB_GAP;
                const visible = new Set();
                const activeTab = contentTabs.find(tab => tab.key === activeHeaderTab);
                if (activeTab) {
                    visible.add(activeTab.key);
                    budget -= widthOf(activeTab.key) + TAB_GAP;
                }
                for (const tab of contentTabs) {
                    if (visible.has(tab.key))
                        continue;
                    const needed = widthOf(tab.key) + TAB_GAP;
                    if (needed > budget)
                        break;
                    visible.add(tab.key);
                    budget -= needed;
                }
                nextVisible = visible;
            }
            setVisibleTabKeys(prev => {
                if (prev === nextVisible)
                    return prev;
                if (prev === null || nextVisible === null)
                    return nextVisible;
                if (prev.size === nextVisible.size && [...prev].every(key => nextVisible.has(key)))
                    return prev;
                return nextVisible;
            });
        };
        recompute();
        const ro = new ResizeObserver(recompute);
        ro.observe(headerRow);
        ro.observe(fullTabs);
        if (globalSearchRef.current)
            ro.observe(globalSearchRef.current);
        const logoEl = headerLeft.querySelector('.revamp-brand-logo');
        if (logoEl && !logoEl.complete) {
            logoEl.addEventListener('load', recompute);
        }
        let cancelled = false;
        (_b = (_a = document.fonts) === null || _a === void 0 ? void 0 : _a.ready) === null || _b === void 0 ? void 0 : _b.then(() => {
            if (!cancelled)
                recompute();
        });
        return () => {
            cancelled = true;
            ro.disconnect();
            logoEl === null || logoEl === void 0 ? void 0 : logoEl.removeEventListener('load', recompute);
        };
    });
    const vendorConfig = useSelector((state) => state.vendor.vendorDetails);
    const guardedFormHasUnsavedData = useSelector((state) => state.form.guardedFormHasUnsavedData);
    const userBasicInfo = useSelector((store) => store.User);
    const dashboardSearchItems = useSelector((state) => state.GlobalSearch.dashboardItems);
    const applicationsSearchItems = useSelector((state) => state.GlobalSearch.applicationsItems);
    const [t] = useTranslation('global');
    const userLanguage = useSelector((store) => store.User.selectedLang);
    const impersonationDetails = useSelector((store) => store.User.impersonationDetails);
    const helpMail = useSelector((store) => store.User.helpMail);
    const navConfig = NavigationConfig;
    const isRevampDashboardHeader = location.pathname === NavigationConfig.Dashboard;
    const isDeeplinkRoute = [navConfig.CreateApplicationDeeplink, navConfig.LineOfCreditDeeplink, navConfig.ScheduleTakedownApplicationDeeplink].some(route => location.pathname.includes(route));
    const showSuperUserBanner = !isDeeplinkRoute && !isRevampDashboardHeader && impersonationDetails && Object.keys(impersonationDetails).length > 0;
    const superUserBannerRef = React.useRef(null);
    useEffect(() => {
        const el = superUserBannerRef.current;
        if (!showSuperUserBanner || !el) {
            document.documentElement.style.setProperty('--super-user-banner-height', '0px');
            return;
        }
        const updateBannerHeight = () => {
            document.documentElement.style.setProperty('--super-user-banner-height', `${el.getBoundingClientRect().height}px`);
        };
        updateBannerHeight();
        const resizeObserver = new ResizeObserver(updateBannerHeight);
        resizeObserver.observe(el);
        return () => resizeObserver.disconnect();
    }, [showSuperUserBanner]);
    const isSuperUser = !!(impersonationDetails && Object.keys(impersonationDetails).length > 0);
    const [marketingBannerItems, setMarketingBannerItems] = React.useState([]);
    const marketingBannerRef = React.useRef(null);
    const fetchMarketingContent = React.useCallback(() => {
        const today = moment();
        api_service.get({
            endPoint: api_urls.MARKETING_CONTENT,
            showLoader: false
        }).then((res) => {
            const msgList = res.data.data;
            const todayNotifications = msgList.filter((item) => {
                const startDate = moment(item.StartDateTime);
                const endDate = moment(item.EndDateTime);
                return today.isSameOrAfter(startDate, 'minute') && today.isSameOrBefore(endDate, 'minute');
            });
            const getNormalizedNotificationType = (item) => { var _a; return String((_a = item === null || item === void 0 ? void 0 : item.NotificationType) !== null && _a !== void 0 ? _a : "").trim().toUpperCase(); };
            const genericContentList = todayNotifications.filter((item) => getNormalizedNotificationType(item) === "GENERAL");
            const genericString = genericContentList.reduce((acc, curr) => {
                if (acc === '') {
                    acc = curr.Message;
                }
                else {
                    acc = `${acc} * ${curr.Message}`;
                }
                return acc;
            }, '');
            const activeBannerItems = todayNotifications
                .filter((item) => ["GENERAL", "PORTAL"].includes(getNormalizedNotificationType(item)))
                .filter((item) => typeof item.Message === "string" && item.Message.trim())
                .map((item, idx) => {
                var _a;
                return ({
                    id: String((_a = item.MarketingContentOId) !== null && _a !== void 0 ? _a : `${getNormalizedNotificationType(item)}-${idx}`),
                    type: getNormalizedNotificationType(item),
                    message: item.Message.trim(),
                });
            })
                .sort((a, b) => (a.type === "GENERAL" ? -1 : b.type === "GENERAL" ? 1 : 0));
            setMarketingBannerItems(activeBannerItems);
            dispatch(user_actions.setGenericMarketingText(genericString));
        }).catch(() => { });
    }, [dispatch]);
    useEffect(() => {
        if (isRevampDashboardHeader)
            fetchMarketingContent();
    }, [isRevampDashboardHeader, fetchMarketingContent]);
    useEffect(() => {
        const el = marketingBannerRef.current;
        if (!isRevampDashboardHeader || !el) {
            document.documentElement.style.setProperty('--marketing-banner-height', '0px');
            return;
        }
        const updateBannerHeight = () => {
            document.documentElement.style.setProperty('--marketing-banner-height', `${el.getBoundingClientRect().height}px`);
        };
        updateBannerHeight();
        const resizeObserver = new ResizeObserver(updateBannerHeight);
        resizeObserver.observe(el);
        return () => resizeObserver.disconnect();
    }, [isRevampDashboardHeader]);
    const userName = `${((_a = userBasicInfo === null || userBasicInfo === void 0 ? void 0 : userBasicInfo.userData) === null || _a === void 0 ? void 0 : _a.firstName) || ''} ${((_b = userBasicInfo === null || userBasicInfo === void 0 ? void 0 : userBasicInfo.userData) === null || _b === void 0 ? void 0 : _b.lastName) || ''}`.trim() || 'User';
    const userEmail = ((_c = userBasicInfo === null || userBasicInfo === void 0 ? void 0 : userBasicInfo.userData) === null || _c === void 0 ? void 0 : _c.email) || '';
    const currentRoleType = ((_d = userBasicInfo === null || userBasicInfo === void 0 ? void 0 : userBasicInfo.userData) === null || _d === void 0 ? void 0 : _d.RoleType) || (userBasicInfo === null || userBasicInfo === void 0 ? void 0 : userBasicInfo.RoleType) || '';
    const userRoleLabel = React.useMemo(() => {
        const roleLabelMap = {
            [constants.roleTypes.VENDSREP]: 'Sales Representative',
            [constants.roleTypes.BRMANAGER]: 'Branch Manager',
            [constants.roleTypes.HQMANAGER]: 'HQ Manager',
            [constants.roleTypes.CUSTOMER_HQMANAGER]: 'Customer HQ Manager',
            [constants.roleTypes.CUSTOMER]: 'Customer',
            [constants.roleTypes.MANUFACTURER]: 'Manufacturer',
        };
        if (roleLabelMap[currentRoleType]) {
            return roleLabelMap[currentRoleType];
        }
        if (!currentRoleType) {
            return 'User';
        }
        return currentRoleType
            .toLowerCase()
            .split('_')
            .map((token) => token.charAt(0).toUpperCase() + token.slice(1))
            .join(' ');
    }, [currentRoleType]);
    const getResultDisplayStatus = (result) => {
        const status = (result === null || result === void 0 ? void 0 : result.Status) || '';
        const aspireStatus = (result === null || result === void 0 ? void 0 : result.AspireStatus) || '';
        const isDocsOut = status === AppStatuses.Documents && aspireStatus.includes(ReDocsStatus);
        const isDocsMissing = status === AppStatuses.Documents && aspireStatus === DocsMissingStatus;
        let derived = status;
        if (status === AppStatuses.Approved && (result === null || result === void 0 ? void 0 : result.ApplicationType) === APPLICATION_TYPES.LOC) {
            const isValid = (result === null || result === void 0 ? void 0 : result.ExpirationDate) &&
                moment.tz(result.ExpirationDate, 'America/New_York').isAfter(moment.tz('America/New_York'));
            derived = isValid ? AppStatuses.ApprovedLoc : AppStatuses.ExpiredLoc;
        }
        if (derived === AppStatuses['Credit More Info'])
            return 'More Info Requested';
        if (derived === AppStatuses.ApprovedLoc)
            return 'Approved LOC / DORF';
        if (derived === AppStatuses.Approved)
            return 'Request Documents';
        if (derived === AppStatuses.Credit)
            return 'In Credit Review';
        if (derived === AppStatuses.Documents) {
            if (isDocsOut)
                return 'Docs Out for Signature';
            if (isDocsMissing)
                return 'Docs Back Missing Info';
            if (aspireStatus === DocsRequestedESignatureStatus)
                return 'Docs Requested Esignature';
            if (aspireStatus === DocsRequestedPdfStatus)
                return 'Docs Requested PDF';
            if (aspireStatus.startsWith('55 - Docs Back'))
                return 'Docs Back';
            return aspireStatus.substring(aspireStatus.indexOf('-') + 1).trim() || 'In Doc Review';
        }
        if (derived === AppStatuses['Saved Applications'])
            return 'Saved App';
        if (derived === AppStatuses.Booked)
            return 'Funded';
        if (derived === AppStatuses.Declined)
            return 'Declined';
        if (derived === AppStatuses.Cancelled)
            return 'Cancelled';
        return derived || '--';
    };
    const getResultStatusIcon = (result) => {
        const status = result.Status || '';
        const aspireStatus = result.AspireStatus || '';
        if (aspireStatus.startsWith('56 - Docs Back') || status === 'Credit More Info') {
            return React.createElement(ApplicationSidebarActionNeededIcon, null);
        }
        if (status === 'Approved' || status === 'ApprovedLoc')
            return React.createElement(ApplicationSidebarApprovedIcon, null);
        if (aspireStatus === '52 - Docs Out')
            return React.createElement(ApplicationSidebarSignFinalizeIcon, null);
        if (status === 'Saved_Applications')
            return React.createElement(ApplicationSidebarInProgressIcon, null);
        if (status === 'Credit' || status === 'Documents')
            return React.createElement(ApplicationSidebarUnderReviewIcon, null);
        if (status === 'Booked')
            return React.createElement(ApplicationSidebarBookedIcon, null);
        return React.createElement(ApplicationSidebarOtherApplicationsIcon, null);
    };
    const findExactIdMatches = (source, query) => {
        const lq = query.toLowerCase();
        return source.filter((item) => (item.ContractAspireId || '').toLowerCase().includes(lq) ||
            (item.ContractAspireRecordId || '').toLowerCase().includes(lq) ||
            (item.TxAspireOId || '').toLowerCase().includes(lq) ||
            (item.Name || '').toLowerCase().includes(lq));
    };
    const searchResults = React.useMemo(() => {
        if (!globalSearchText || globalSearchText.length < 3)
            return [];
        let source;
        if (globalSearchActiveTab === 'dashboard') {
            source = dashboardSearchItems.length > 0
                ? dashboardSearchItems
                : applicationsSearchItems.filter((item) => DASHBOARD_KPI_STATUSES.has(item.Status));
        }
        else {
            source = applicationsSearchItems;
        }
        if (!source.length)
            return [];
        const query = globalSearchText.trim();
        const looksLikeId = /\d/.test(query) || /^[A-Z0-9-]+$/i.test(query);
        if (looksLikeId) {
            return findExactIdMatches(source, query).slice(0, 50);
        }
        const fuse = new Fuse(source, {
            keys: ['Name', 'ContractAspireId', 'ContractAspireRecordId', 'TxAspireOId'],
            threshold: 0.3,
            minMatchCharLength: 3,
        });
        return fuse.search(query).slice(0, 50).map((r) => r.item);
    }, [globalSearchText, globalSearchActiveTab, dashboardSearchItems, applicationsSearchItems]);
    const guardedSearchAction = (action) => {
        if (isCurrentFormDirty) {
            pendingSearchCallbackRef.current = action;
            setOpenQuoteToolUnsavedPopup(true);
            return;
        }
        action();
    };
    const handleSearchNavigate = () => {
        if (searchResults.length === 1) {
            handleResultClick(searchResults[0]);
            return;
        }
        const activeTab = globalSearchActiveTab;
        const text = globalSearchText;
        guardedSearchAction(() => {
            dispatch(globalSearch_actions.setDisplayText(''));
            setGlobalSearchOpen(false);
            setGlobalSearchCategoryOpen(false);
            const target = activeTab === 'dashboard' ? navConfig.Dashboard : navConfig.Applications;
            navigate(target, { state: { globalSearchText: text } });
        });
    };
    const handleResultClick = (result) => {
        var _a, _b, _c, _d;
        const parts = [result.Name];
        if (result.ContractAspireId)
            parts.push(` - CID: ${result.ContractAspireId}`);
        if (result.TxAspireOId)
            parts.push(`TN: ${result.TxAspireOId}`);
        const displayText = parts.join('   ');
        const rawQuery = result.TxAspireOId || result.ContractAspireId || result.Name || '';
        const activeTab = globalSearchActiveTab;
        const selectedResult = {
            Status: (_a = result.Status) !== null && _a !== void 0 ? _a : null,
            AspireStatus: (_b = result.AspireStatus) !== null && _b !== void 0 ? _b : null,
            ApplicationType: (_c = result.ApplicationType) !== null && _c !== void 0 ? _c : null,
            ExpirationDate: (_d = result.ExpirationDate) !== null && _d !== void 0 ? _d : null,
        };
        guardedSearchAction(() => {
            dispatch(globalSearch_actions.setDisplayText(displayText));
            setGlobalSearchOpen(false);
            setGlobalSearchCategoryOpen(false);
            if (activeTab === 'dashboard') {
                navigate(navConfig.Dashboard, { state: { globalSearchText: rawQuery } });
            }
            else {
                navigate(navConfig.Applications, { state: { globalSearchText: rawQuery, selectedResult } });
            }
        });
    };
    const headerTabs = [
        { labelKey: 'DASHBOARD_HEADER.DASHBOARD', key: 'dashboard', hidden: false },
        { labelKey: 'DASHBOARD_HEADER.ALL_APPLICATIONS', key: 'applications', hidden: false },
        {
            labelKey: 'DASHBOARD_HEADER.QUOTE_TOOL',
            key: 'quoteTool',
            hidden: !(vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.IsQuoteToolEnabled),
        },
        {
            labelKey: 'DASHBOARD_HEADER.SENT_APPLICATIONS',
            key: 'sentApplications',
            hidden: !((currentRoleType !== constants.roleTypes.CUSTOMER_HQMANAGER && (vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.IsSendAppEnabled) == 1) || (impersonationDetails === null || impersonationDetails === void 0 ? void 0 : impersonationDetails.AdminId)),
        },
        { labelKey: 'DASHBOARD_HEADER.MORE', key: 'more', hidden: false },
    ];
    const isLangMenuOpen = Boolean(langMenuAnchorEl);
    const isNotificationsOpen = Boolean(notificationsAnchorEl);
    const visibleNotificationTabs = React.useMemo(() => headerNotificationTabs.filter((tab) => tab.isVisible), []);
    const guardedFormRoutes = [
        NavigationConfig.QuoteTool,
        NavigationConfig.SendApplicationLink,
        NavigationConfig.CreateApplication,
        NavigationConfig.UpdateApplication,
        NavigationConfig.LineOfCredit,
        NavigationConfig.UpdateLineOfCredit,
        NavigationConfig.DealerOperatedRentalFleet,
        NavigationConfig.UpdateDealerOperatedRentalFleet,
        NavigationConfig.ScheduleTakedownApplication,
    ];
    const isFormGuardedRoute = guardedFormRoutes.some((route) => location.pathname.includes(route));
    const isCurrentFormDirty = React.useMemo(() => {
        return isFormGuardedRoute ? guardedFormHasUnsavedData : false;
    }, [guardedFormHasUnsavedData, isFormGuardedRoute]);
    const applicationFormRoutes = [
        NavigationConfig.CreateApplication,
        NavigationConfig.UpdateApplication,
        NavigationConfig.LineOfCredit,
        NavigationConfig.UpdateLineOfCredit,
        NavigationConfig.DealerOperatedRentalFleet,
        NavigationConfig.UpdateDealerOperatedRentalFleet,
        NavigationConfig.ScheduleTakedownApplication,
    ];
    const isApplicationFormRoute = applicationFormRoutes.some((route) => location.pathname.includes(route));
    const editType = (_e = location.state) === null || _e === void 0 ? void 0 : _e.editType;
    const isExitScenario = isApplicationFormRoute && (editType === EDIT_TYPES_ENUMS.APPROVED ||
        editType === EDIT_TYPES_ENUMS.DOCUMENTS ||
        editType === EDIT_TYPES_ENUMS.IN_CREDIT_MORE_INFO);
    const handleGuardedNavigation = (targetRoute) => {
        if (isFormGuardedRoute && location.pathname !== targetRoute) {
            setPendingHeaderNavigation(targetRoute);
            setOpenQuoteToolUnsavedPopup(true);
            return;
        }
        dispatch(globalSearch_actions.clearSearch());
        navigate(targetRoute);
    };
    const closeGuardedNavigationPopup = React.useCallback(() => {
        setOpenQuoteToolUnsavedPopup(false);
        setPendingHeaderNavigation('');
        pendingSearchCallbackRef.current = null;
    }, []);
    const confirmGuardedNavigation = React.useCallback(() => {
        setOpenQuoteToolUnsavedPopup(false);
        if (pendingHeaderNavigation) {
            dispatch(globalSearch_actions.clearSearch());
            navigate(pendingHeaderNavigation);
        }
        else if (pendingSearchCallbackRef.current) {
            pendingSearchCallbackRef.current();
        }
        setPendingHeaderNavigation('');
        pendingSearchCallbackRef.current = null;
    }, [navigate, pendingHeaderNavigation]);
    const getActiveHeaderTab = () => {
        const pathname = location.pathname;
        if (pathname.includes(NavigationConfig.QuoteTool) || pathname.includes(NavigationConfig.QuoteHistory) || pathname.includes(NavigationConfig.QuotePreview)) {
            return 'quoteTool';
        }
        if ([
            NavigationConfig.Applications,
            NavigationConfig.CreateApplication,
            NavigationConfig.UpdateApplication,
            NavigationConfig.LineOfCredit,
            NavigationConfig.UpdateLineOfCredit,
            NavigationConfig.DealerOperatedRentalFleet,
            NavigationConfig.UpdateDealerOperatedRentalFleet,
            NavigationConfig.ScheduleTakedownApplication,
        ].some((route) => pathname.includes(route))) {
            return 'applications';
        }
        if (pathname.includes(NavigationConfig.DeepLinkMail) || pathname.includes(NavigationConfig.SendApplicationLink)) {
            return 'sentApplications';
        }
        if (pathname.includes(NavigationConfig.AnalyticsDashboard)) {
            return 'more';
        }
        return 'dashboard';
    };
    const getRevampNavIcon = (tabKey, isActive) => {
        switch (tabKey) {
            case 'dashboard':
                return React.createElement(DashboardNavIcon, { isActive: isActive });
            case 'applications':
                return React.createElement(ApplicationsNavIcon, { isActive: isActive });
            case 'quoteTool':
                return React.createElement(QuoteToolNavIcon, { isActive: isActive });
            case 'sentApplications':
                return React.createElement(SentApplicationsNavIcon, { isActive: isActive });
            case 'more':
                return React.createElement(MoreNavIcon, { isActive: isActive });
            default:
                return null;
        }
    };
    const handleHeaderTabClick = (tabKey, event) => {
        var _a;
        switch (tabKey) {
            case 'dashboard':
                handleGuardedNavigation(NavigationConfig.Dashboard);
                break;
            case 'applications':
                handleGuardedNavigation(NavigationConfig.Applications);
                break;
            case 'quoteTool':
                handleGuardedNavigation(NavigationConfig.QuoteHistory);
                break;
            case 'sentApplications':
                handleGuardedNavigation(NavigationConfig.DeepLinkMail);
                break;
            case 'more':
                setMoreMenuAnchorEl((_a = event === null || event === void 0 ? void 0 : event.currentTarget) !== null && _a !== void 0 ? _a : null);
                break;
            default:
                break;
        }
    };
    const closeMoreMenu = () => setMoreMenuAnchorEl(null);
    const pendingMoreMenuActionRef = React.useRef(null);
    const runAfterMoreMenuCloses = (action) => {
        pendingMoreMenuActionRef.current = action;
        closeMoreMenu();
    };
    const handleMoreItemClick = (item) => {
        switch (item) {
            case 'analytics':
                runAfterMoreMenuCloses(() => handleGuardedNavigation(NavigationConfig.AnalyticsDashboard));
                break;
            case 'rateCard':
                closeMoreMenu();
                if (vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.RateCardUrl)
                    window.open(vendorConfig.RateCardUrl, '_blank');
                break;
            case 'faq':
                closeMoreMenu();
                if (vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.FAQUrl)
                    window.open(vendorConfig.FAQUrl, '_blank');
                break;
            case 'needHelp':
                closeMoreMenu();
                setNeedhelp(true);
                break;
        }
    };
    const openLanguageMenu = (event) => {
        setLangMenuAnchorEl(event.currentTarget);
    };
    const closeLanguageMenu = () => {
        setLangMenuAnchorEl(null);
    };
    const handleLanguageSelect = (value) => {
        handleLangChange({
            target: { name: 'language', value }
        });
        closeLanguageMenu();
    };
    const openProfileMenu = () => {
        setIsProfileMenuOpen(true);
    };
    const openNotificationsPopup = (event) => {
        setNotificationsAnchorEl(event.currentTarget);
        setActiveNotificationTab('announcements');
        fetchMarketingAnnouncements();
    };
    const closeNotificationsPopup = () => {
        setNotificationsAnchorEl(null);
    };
    const fetchMarketingAnnouncements = React.useCallback(() => {
        const now = moment();
        api_service.get({
            endPoint: api_urls.MARKETING_CONTENT,
            showLoader: false,
        }).then((res) => {
            var _a;
            const responseList = Array.isArray((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data) ? res.data.data : [];
            const activeItems = responseList.filter((item) => {
                const startDate = moment(item === null || item === void 0 ? void 0 : item.StartDateTime);
                const endDate = moment(item === null || item === void 0 ? void 0 : item.EndDateTime);
                if (!startDate.isValid() || !endDate.isValid()) {
                    return false;
                }
                return now.isSameOrAfter(startDate, 'minute') && now.isSameOrBefore(endDate, 'minute');
            });
            const mappedItems = activeItems
                .filter((item) => typeof (item === null || item === void 0 ? void 0 : item.Message) === 'string' && item.Message.trim())
                .map((item, idx) => {
                var _a, _b, _c, _d, _e;
                const normalizedType = String((_a = item === null || item === void 0 ? void 0 : item.NotificationType) !== null && _a !== void 0 ? _a : '').trim().toUpperCase();
                const badgeText = normalizedType === 'GENERAL'
                    ? t('Dashboard.GeneralNotification', { defaultValue: 'General Notification' })
                    : normalizedType === 'PORTAL'
                        ? t('Dashboard.PortalNotification', { defaultValue: 'Portal Notification' })
                        : t('DASHBOARD_HEADER.ANNOUNCEMENTS_UPDATES', { defaultValue: 'Announcements & Updates' });
                const title = String((_d = (_c = (_b = item === null || item === void 0 ? void 0 : item.Title) !== null && _b !== void 0 ? _b : item === null || item === void 0 ? void 0 : item.Subject) !== null && _c !== void 0 ? _c : item === null || item === void 0 ? void 0 : item.NotificationTitle) !== null && _d !== void 0 ? _d : '').trim() || badgeText;
                const timestamp = (item === null || item === void 0 ? void 0 : item.StartDateTime)
                    ? moment(item.StartDateTime).format('MM/DD/YYYY | hh:mm A')
                    : '--';
                return {
                    id: String((_e = item === null || item === void 0 ? void 0 : item.MarketingContentOId) !== null && _e !== void 0 ? _e : `marketing-${idx}`),
                    badgeText,
                    title,
                    description: item.Message.trim(),
                    timestamp,
                    linkLabel: t('Learn More', { defaultValue: 'Learn More' }),
                    isUnread: true,
                };
            });
            setAnnouncementItems(mappedItems);
        }).catch(() => {
            setAnnouncementItems([]);
        });
    }, [t]);
    const closeProfileMenu = () => {
        setIsProfileMenuOpen(false);
    };
    const [state, setState] = React.useState({
        left: false,
    });
    const [openNeedhelp, setNeedhelp] = React.useState(false);
    const tooltipRef = React.useRef(null);
    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' &&
            (event.key === 'Tab' ||
                event.key === 'Shift')) {
            return;
        }
        setState(Object.assign(Object.assign({}, state), { [anchor]: open }));
    };
    const handleClickOutside = (event) => {
        if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
            setNeedhelp(false);
        }
    };
    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    const fetchApplicationsForGlobalSearch = React.useCallback(() => {
        if (applicationsSearchItems.length > 0)
            return;
        api_service
            .get({ endPoint: api_urls.GET_APPLICATIONS_LIST, payLoad: { isAutoRefresh: 0 }, showLoader: false })
            .then((res) => {
            var _a, _b;
            if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 200 && Array.isArray((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.data)) {
                dispatch(globalSearch_actions.setApplicationsSearchItems(res.data.data));
            }
        })
            .catch(() => { });
    }, [applicationsSearchItems.length]);
    useEffect(() => {
        if (globalSearchOpen && globalSearchActiveTab === 'all') {
            fetchApplicationsForGlobalSearch();
        }
    }, [globalSearchOpen, globalSearchActiveTab]);
    useEffect(() => {
        if (!pendingContractIdSearch)
            return;
        fetchApplicationsForGlobalSearch();
    }, [pendingContractIdSearch]);
    useEffect(() => {
        if (!pendingContractIdSearch || applicationsSearchItems.length === 0)
            return;
        const matches = findExactIdMatches(applicationsSearchItems, pendingContractIdSearch);
        if (matches.length > 0) {
            handleResultClick(matches[0]);
        }
        else {
            guardedSearchAction(() => {
                navigate(navConfig.Applications, { state: { globalSearchText: pendingContractIdSearch } });
            });
        }
        dispatch(globalSearch_actions.clearPendingContractIdSearch());
    }, [pendingContractIdSearch, applicationsSearchItems]);
    const sidebarItems = [
        {
            key: 'dashboard',
            label: t('DASHBOARD_HEADER.DASHBOARD'),
            hidden: false,
            onClick: () => handleGuardedNavigation(NavigationConfig.Dashboard),
            getIcon: (isActive) => React.createElement(DashboardNavIcon, { isActive: isActive }),
        },
        {
            key: 'applications',
            label: t('DASHBOARD_HEADER.ALL_APPLICATIONS'),
            hidden: false,
            onClick: () => handleGuardedNavigation(NavigationConfig.Applications),
            getIcon: (isActive) => React.createElement(ApplicationsNavIcon, { isActive: isActive }),
        },
        {
            key: 'quoteTool',
            label: t('DASHBOARD_HEADER.QUOTE_TOOL'),
            hidden: !(vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.IsQuoteToolEnabled),
            onClick: () => handleGuardedNavigation(NavigationConfig.QuoteHistory),
            getIcon: (isActive) => React.createElement(QuoteToolNavIcon, { isActive: isActive }),
        },
        {
            key: 'sentApplications',
            label: t('DASHBOARD_HEADER.SENT_APPLICATIONS'),
            hidden: !((currentRoleType !== constants.roleTypes.CUSTOMER_HQMANAGER && (vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.IsSendAppEnabled) == 1) || (impersonationDetails === null || impersonationDetails === void 0 ? void 0 : impersonationDetails.AdminId)),
            onClick: () => handleGuardedNavigation(NavigationConfig.DeepLinkMail),
            getIcon: (isActive) => React.createElement(SentApplicationsNavIcon, { isActive: isActive }),
        },
        {
            key: 'analytics',
            label: t('Dashboard.SideMenuOptions.Analytics'),
            hidden: !(vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.IsAnalyticsEnabled) || ((_f = userBasicInfo === null || userBasicInfo === void 0 ? void 0 : userBasicInfo.userData) === null || _f === void 0 ? void 0 : _f.RoleType) === constants.roleTypes.CUSTOMER_HQMANAGER,
            onClick: () => handleGuardedNavigation(NavigationConfig.AnalyticsDashboard),
            getIcon: (_isActive) => React.createElement(AnalyticsIcon, null),
        },
        {
            key: 'rateCard',
            label: t('Dashboard.SideMenuOptions.Rate Card'),
            hidden: !(vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.RateCardUrl),
            onClick: () => { window.open(vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.RateCardUrl, '_blank'); },
            getIcon: (_isActive) => React.createElement(RateCard, null),
        },
        {
            key: 'faq',
            label: t('Dashboard.SideMenuOptions.FAQ'),
            hidden: !(vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.FAQUrl),
            onClick: () => { window.open(vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.FAQUrl, '_blank'); },
            getIcon: (_isActive) => React.createElement(FAQIcon, null),
        },
        {
            key: 'needHelp',
            label: t('NeedHelp.Heading'),
            hidden: false,
            onClick: () => setNeedhelp(true),
            getIcon: (_isActive) => React.createElement(SupportIcon, null),
        },
    ];
    const list = (anchor) => {
        const activeSidebarKey = location.pathname.includes(NavigationConfig.AnalyticsDashboard)
            ? 'analytics'
            : getActiveHeaderTab();
        return (React.createElement(Box, { role: "presentation", onClick: toggleDrawer(anchor, false), onKeyDown: toggleDrawer(anchor, false), sx: { width: 300, height: '100%', backgroundColor: '#FFFFFF', display: 'flex', flexDirection: 'column' } },
            React.createElement(Box, { sx: { pt: '14px', pb: '14px', pl: '14px' } },
                React.createElement("img", { src: (vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.LandingLogoUrl) ? vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.LandingLogoUrl : AuxiliorHorizontalLogo, alt: "Brand Logo", style: { height: 'auto', width: '120px', minWidth: '120px' } })),
            React.createElement(List, { sx: { p: 0, flex: 1 } }, sidebarItems
                .filter(item => !item.hidden)
                .map(item => {
                const isActive = item.key === activeSidebarKey;
                return (React.createElement(ListItem, { key: item.key, disablePadding: true },
                    React.createElement(ListItemButton, { onClick: item.onClick, sx: {
                            borderRadius: 0,
                            backgroundColor: isActive ? colors.Primary : 'transparent',
                            '&:hover': {
                                backgroundColor: isActive ? colors.Primary : 'rgba(0,0,0,0.04)',
                            },
                            '& svg path': isActive ? { fill: getContrastText(colors.Primary), stroke: getContrastText(colors.Primary) } : {},
                            '& svg rect': isActive ? { stroke: getContrastText(colors.Primary) } : {},
                        } },
                        React.createElement(ListItemIcon, { sx: { minWidth: '40px', color: isActive ? getContrastText(colors.Primary) : '#6B7280' } }, item.getIcon(isActive)),
                        React.createElement(ListItemText, { primary: item.label, primaryTypographyProps: {
                                fontSize: '16px',
                                fontWeight: isActive ? 500 : 400,
                                color: isActive ? getContrastText(colors.Primary) : '#4B5563',
                                fontFamily: 'var(--font-family)',
                            } }))));
            })),
            React.createElement(Box, { onClick: (e) => e.stopPropagation(), onKeyDown: (e) => e.stopPropagation(), sx: { px: 2, pb: 3, pt: 1.5, borderTop: '1px solid #F0F0F2', display: 'flex', flexDirection: 'column', gap: 2 } },
                React.createElement(Button, { disableRipple: true, onClick: openLanguageMenu, sx: {
                        textTransform: 'none',
                        bgcolor: '#F3F4F6',
                        borderRadius: '8px',
                        px: 1.5,
                        py: 0.75,
                        gap: 1,
                        justifyContent: 'flex-start',
                        color: '#4B5563',
                        width: 'fit-content',
                        '&:hover': { bgcolor: '#E9EAEC' },
                    } },
                    React.createElement(GlobeDesignIcon, null),
                    React.createElement(Typography, { sx: { fontSize: '14px', fontWeight: 500, color: '#4B5563' } }, (selectedLangCode || Language.ENGLISH).toUpperCase()),
                    React.createElement(ChevronDownDesignIcon, null)),
                React.createElement(Menu, { anchorEl: langMenuAnchorEl, open: isLangMenuOpen, onClose: closeLanguageMenu, className: 'revamp-lang-menu' }, LanguageOptions.map((langItem) => (React.createElement(MenuItem, { key: langItem.value, selected: selectedLangCode === langItem.value, onClick: () => handleLanguageSelect(langItem.value) }, langItem.lang)))),
                React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1.5 } },
                    React.createElement(Box, { sx: { flex: 1, minWidth: 0 } },
                        React.createElement(Typography, { sx: { fontSize: '14px', fontWeight: 600, color: '#111827', lineHeight: 1.3, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } }, userName),
                        React.createElement(Typography, { sx: { fontSize: '12px', color: '#6B7280', lineHeight: 1.4, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } }, userRoleLabel)),
                    React.createElement(IconButton, { sx: { flexShrink: 0, p: 0 }, onClick: openProfileMenu },
                        React.createElement(ProfilePictureIcon, null))))));
    };
    const logout = () => __awaiter(this, void 0, void 0, function* () {
        yield dispatch(loginSignup_asyncActions.logout());
        navigate(NavigationConfig.Account.Login);
    });
    const handleLangChange = (e) => {
        let { name, value } = e.target;
        if (![navConfig.CreateApplicationDeeplink, navConfig.LineOfCreditDeeplink, navConfig.ScheduleTakedownApplicationDeeplink].some(route => location.pathname.includes(route))) {
            api_service.put({
                endPoint: api_urls.TRANSLATION_LANGUAGE,
                payLoad: {
                    LanguageCode: value
                },
                showLoader: false
            }).then((res => {
                var _a;
                if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.statusCode) === 200) {
                    i18next.changeLanguage(value);
                    setSelectedLangCode(value);
                    dispatch(user_actions.setSelectedLang(value));
                }
            })).catch((error) => {
                utility.alert("something went wrong, please try again later");
            });
        }
        else {
            i18next.changeLanguage(value);
            setSelectedLangCode(value);
            dispatch(user_actions.setSelectedLang(value));
        }
    };
    const getSelectedLang = () => {
        const langObj = LanguageOptions.find((lngItem) => lngItem.value === selectedLangCode);
        return langObj;
    };
    useEffect(() => {
        getSelectedLang();
    }, [selectedLangCode]);
    useEffect(() => {
        const safeLanguage = normalizeLanguageCode(userLanguage);
        i18next.changeLanguage(safeLanguage);
        setSelectedLangCode(safeLanguage);
    }, []);
    useEffect(() => {
        const safeLanguage = normalizeLanguageCode(userLanguage);
        if (selectedLangCode !== safeLanguage) {
            i18next.changeLanguage(safeLanguage);
            setSelectedLangCode(safeLanguage);
        }
    }, [userLanguage]);
    const LightTooltip = styled((_a) => {
        var { className } = _a, props = __rest(_a, ["className"]);
        return (React.createElement(Tooltip, Object.assign({}, props, { classes: { popper: className }, placement: 'bottom', arrow: true })));
    })(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            color: 'white',
            boxShadow: theme.shadows[1],
            fontSize: 11,
            width: 270,
            marginRight: 2
        },
    }));
    return (React.createElement(Box, { sx: { flexGrow: 1 } },
        React.createElement(AppBar, { position: "fixed", className: 'revamp-appbar' },
            React.createElement(Toolbar, { disableGutters: true },
                React.createElement(Box, { className: 'revamp-header', ref: headerRowRef, sx: { position: 'relative' } },
                    isMobileHeader && !isDeeplinkRoute && mobileSearchOpen && (React.createElement(Box, { ref: globalSearchRef, sx: {
                            position: 'absolute',
                            inset: 0,
                            backgroundColor: '#fff',
                            zIndex: 10,
                            display: 'flex',
                            alignItems: 'center',
                            px: 1.5,
                            gap: 1,
                        } },
                        React.createElement(Box, { sx: { flex: 1, minWidth: 0, position: 'relative' } },
                            React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', height: '36px', width: '100%' } },
                                React.createElement(Box, { sx: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        px: 1,
                                        height: '36px',
                                        width: '104px',
                                        flexShrink: 0,
                                        background: '#F2F2F3',
                                        border: '1px solid #000000',
                                        borderRadius: '8px 0 0 8px',
                                        cursor: 'pointer',
                                        userSelect: 'none',
                                        boxSizing: 'border-box',
                                    }, onClick: () => setGlobalSearchCategoryOpen((prev) => !prev), ref: categoryTriggerRef },
                                    React.createElement(Typography, { component: "p", className: "revamp-search-header-text", sx: { fontSize: '14px', color: '#3D3D42', fontWeight: 400, lineHeight: '20px', m: 0 } }, globalSearchActiveTab === 'dashboard'
                                        ? t('GLOBAL_SEARCH.Dashboard')
                                        : t('GLOBAL_SEARCH.All')),
                                    React.createElement(Box, { component: "svg", viewBox: "0 0 10 10", sx: { width: 10, height: 10, flexShrink: 0 } },
                                        React.createElement("path", { d: "M2 3.5l3 3 3-3", stroke: "#6E6E77", strokeWidth: "0.9375", fill: "none", strokeLinecap: "round", strokeLinejoin: "round" }))),
                                React.createElement(Box, { sx: {
                                        flex: 1,
                                        minWidth: 0,
                                        display: 'flex',
                                        alignItems: 'center',
                                        height: '36px',
                                        background: '#FFF',
                                        borderWidth: '1px 1px 1px 0',
                                        borderStyle: 'solid',
                                        borderColor: '#000000',
                                        borderRadius: '0 8px 8px 0',
                                        boxSizing: 'border-box',
                                        px: 1,
                                        gap: 1,
                                    } },
                                    React.createElement(Box, { sx: { flex: 1, minWidth: 0 } },
                                        React.createElement(AppHeaderSearch, { className: "revamp-search-header-text", value: globalSearchText, placeholder: globalSearchActiveTab === 'dashboard' ? t('GLOBAL_SEARCH.PlaceholderDashboard') : t('GLOBAL_SEARCH.PlaceholderAll'), onChange: (v) => setGlobalSearchText(v), showClear: false, matchCount: globalSearchText.length >= 3 ? searchResults.length : undefined, inputProps: {
                                                autoFocus: true,
                                                onKeyDown: (e) => {
                                                    if (e.key === 'Enter')
                                                        handleSearchNavigate();
                                                },
                                            }, sx: {
                                                width: '100%',
                                                background: 'transparent',
                                                fontSize: '14px',
                                                '& .MuiOutlinedInput-root': { background: 'transparent', px: 0 },
                                                '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
                                                '&:hover .MuiOutlinedInput-notchedOutline': { border: 'none' },
                                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': { border: 'none' },
                                            } })),
                                    React.createElement(IconButton, { size: "small", sx: { p: 0.5, flexShrink: 0, color: '#9CA3AF' }, onClick: () => {
                                            dispatch(globalSearch_actions.clearSearch());
                                            setGlobalSearchCategoryOpen(false);
                                        } },
                                        React.createElement(CloseIcon, { sx: { fontSize: 16 } })))),
                            globalSearchCategoryOpen && (React.createElement(Box, { ref: categoryDropdownRef, sx: {
                                    position: 'absolute',
                                    top: '44px',
                                    left: '7px',
                                    width: 'max-content',
                                    minWidth: '135px',
                                    background: '#FFFFFF',
                                    border: '1px solid #D7D7DA',
                                    borderRadius: '4px',
                                    zIndex: 1202,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    p: '12px',
                                    gap: '10px',
                                    boxSizing: 'border-box',
                                } }, [
                                { key: 'all', label: t('GLOBAL_SEARCH.AllApplications') },
                                { key: 'dashboard', label: t('GLOBAL_SEARCH.Dashboard') },
                            ].map((item) => (React.createElement(Box, { key: item.key, onClick: () => {
                                    setGlobalSearchActiveTab(item.key);
                                    setGlobalSearchCategoryOpen(false);
                                }, sx: { cursor: 'pointer', whiteSpace: 'nowrap' } },
                                React.createElement("p", { style: { margin: 0, fontSize: '16px', fontWeight: 400, lineHeight: '19px', color: globalSearchActiveTab === item.key ? '#000000' : '#A2A2A9', fontFamily: 'var(--font-family)' } }, item.label)))))),
                            globalSearchText.length >= 3 && (React.createElement(Box, { sx: {
                                    position: 'absolute',
                                    top: 'calc(100% + 4px)',
                                    left: 0,
                                    right: 0,
                                    background: '#FFFFFF',
                                    borderRadius: '8px',
                                    border: '1px solid #E8E8EC',
                                    boxShadow: '0px 4px 16px rgba(0,0,0,0.08)',
                                    zIndex: 1200,
                                    overflow: 'hidden',
                                    pt: '16px',
                                    pb: 0,
                                } },
                                React.createElement(Typography, { sx: { fontSize: '16px', fontWeight: 600, color: '#A2A2A9', lineHeight: '19px', px: 2, pb: 1 } }, globalSearchActiveTab === 'dashboard'
                                    ? t('GLOBAL_SEARCH.Dashboard')
                                    : t('GLOBAL_SEARCH.AllApplications')),
                                React.createElement(Box, { sx: { maxHeight: '60vh', overflowY: 'auto' } }, searchResults.length === 0 ? (React.createElement(Box, { sx: { px: 2, textAlign: 'center', py: 2.5 } },
                                    React.createElement(Typography, { sx: { fontSize: '14px', color: '#A2A2A9' } }, globalSearchText.length >= 3 ? t('GLOBAL_SEARCH.NoResults') : ''))) : (searchResults.map((result, idx) => (React.createElement(Box, { key: idx },
                                    React.createElement(Box, { onClick: () => { handleResultClick(result); setMobileSearchOpen(false); }, sx: {
                                            display: 'flex',
                                            flexDirection: 'column',
                                            px: 2,
                                            pt: '4px',
                                            pb: '4px',
                                            gap: '4px',
                                            minHeight: '60px',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                            '&:hover': { background: '#F9FAFB' },
                                            '& *': { pointerEvents: 'none' },
                                        } },
                                        React.createElement(Typography, { sx: { fontSize: '14px', fontWeight: 400, color: '#000000', lineHeight: '20px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } }, result.Name),
                                        React.createElement(Box, { sx: { display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', rowGap: 0.5 } },
                                            React.createElement(Box, { sx: { display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1.5, rowGap: 0.25, minWidth: 0 } },
                                                React.createElement(Typography, { sx: { fontSize: '14px', fontWeight: 400, color: '#6E6E77', lineHeight: '16px', whiteSpace: 'nowrap' } },
                                                    'Contract ID: ',
                                                    React.createElement(Typography, { component: "span", sx: { fontSize: '14px', fontWeight: 600, color: '#6E6E77', lineHeight: '16px' } }, result.ContractAspireId || result.ContractAspireRecordId || '--'))),
                                            React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 } },
                                                React.createElement(Typography, { sx: { fontSize: '12px', fontWeight: 400, color: '#A2A2A9', lineHeight: '14px', whiteSpace: 'nowrap' } },
                                                    t('GLOBAL_SEARCH.Status'),
                                                    ': ',
                                                    React.createElement(Box, { component: "span", sx: { fontWeight: 500, color: '#6E6E77' } }, getResultDisplayStatus(result))),
                                                React.createElement(Box, { sx: { width: 20, height: 20, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' } }, getResultStatusIcon(result))))),
                                    React.createElement(Divider, { sx: { borderColor: '#BDBDC2' } }))))))))),
                        React.createElement(IconButton, { size: "small", sx: { flexShrink: 0, color: '#6B7280' }, onClick: () => {
                                setMobileSearchOpen(false);
                                setGlobalSearchOpen(false);
                                setGlobalSearchCategoryOpen(false);
                                dispatch(globalSearch_actions.clearSearch());
                            } },
                            React.createElement(CloseIcon, null)))),
                    React.createElement(Box, { className: 'revamp-header-left', ref: headerLeftRef },
                        !isDeeplinkRoute && isMobileHeader && (React.createElement(IconButton, { className: 'revamp-mobile-menu-btn', onClick: toggleDrawer('left', true) },
                            React.createElement(MenuIcon, null))),
                        React.createElement("img", { src: (vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.LandingLogoUrl) ? vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.LandingLogoUrl : AuxiliorHorizontalLogo, alt: "Brand Logo", className: 'revamp-brand-logo' }),
                        !isDeeplinkRoute && !isMobileHeader && (React.createElement(Box, { className: 'revamp-header-tabs' }, (() => {
                            const activeHeaderTab = getActiveHeaderTab();
                            const isCollapsing = visibleTabKeys !== null;
                            return headerTabs
                                .filter(tab => !tab.hidden)
                                .map((tab) => {
                                const isActive = tab.key === activeHeaderTab;
                                const isTabActive = isActive || (tab.key === 'more' && Boolean(moreMenuAnchorEl));
                                const isVisible = !isCollapsing || visibleTabKeys.has(tab.key) || tab.key === 'more';
                                const hideLabel = isCollapsing && tab.key === 'more';
                                return (React.createElement(Box, { key: tab.key, sx: {
                                        overflow: 'hidden',
                                        maxWidth: isVisible ? '240px' : '0px',
                                        opacity: isVisible ? 1 : 0,
                                        marginRight: isVisible ? '8px' : '0px',
                                        pointerEvents: isVisible ? 'auto' : 'none',
                                        transition: 'max-width 0.25s ease, opacity 0.2s ease, margin-right 0.25s ease',
                                        '&:last-of-type': { marginRight: 0 },
                                    } },
                                    React.createElement(Button, { className: `revamp-tab ${isTabActive ? 'active' : ''}`, disableElevation: true, disableRipple: true, tabIndex: isVisible ? 0 : -1, onClick: (e) => handleHeaderTabClick(tab.key, e), variant: 'text', sx: Object.assign(Object.assign({ whiteSpace: 'nowrap' }, (hideLabel ? { minWidth: 'unset', px: 1 } : {})), { fontFamily: 'var(--font-family)' }) },
                                        getRevampNavIcon(tab.key, isTabActive),
                                        !hideLabel && React.createElement("span", { className: "revamp-tab-label" }, t(tab.labelKey)))));
                            });
                        })())),
                        !isDeeplinkRoute && !isMobileHeader && (React.createElement(Box, { ref: fullTabsMeasureRef, "aria-hidden": true, sx: { position: 'absolute', visibility: 'hidden', pointerEvents: 'none', height: 0, overflow: 'hidden', display: 'flex', alignItems: 'center', top: 0, left: 0 } }, headerTabs.filter(tab => !tab.hidden).map((tab) => {
                            const isTabActive = tab.key === getActiveHeaderTab();
                            return (React.createElement(Button, { key: tab.key, ref: (el) => {
                                    if (el)
                                        tabWidthRefsMap.current.set(tab.key, el);
                                    else
                                        tabWidthRefsMap.current.delete(tab.key);
                                }, className: `revamp-tab ${isTabActive ? 'active' : ''}`, disableElevation: true, disableRipple: true, variant: 'text', tabIndex: -1, sx: { whiteSpace: 'nowrap', fontFamily: 'var(--font-family)', mr: 1, '&:last-of-type': { mr: 0 } } },
                                getRevampNavIcon(tab.key, isTabActive),
                                React.createElement("span", { className: "revamp-tab-label" }, t(tab.labelKey))));
                        }))),
                        !isDeeplinkRoute && !isMobileHeader && (React.createElement(Box, { "aria-hidden": true, sx: { position: 'absolute', visibility: 'hidden', pointerEvents: 'none', height: 0, overflow: 'hidden', display: 'flex', alignItems: 'center', top: 0, left: 0 } },
                            React.createElement(Button, { ref: (el) => {
                                    if (el)
                                        tabWidthRefsMap.current.set('more-collapsed', el);
                                    else
                                        tabWidthRefsMap.current.delete('more-collapsed');
                                }, className: 'revamp-tab', disableElevation: true, disableRipple: true, variant: 'text', tabIndex: -1, sx: { minWidth: 'unset', px: 1, fontFamily: 'var(--font-family)' } }, getRevampNavIcon('more', false))))),
                    !isDeeplinkRoute && !isMobileHeader && (React.createElement(Box, { className: 'revamp-header-flex-spacer', sx: { flexGrow: 1, minWidth: 0 } })),
                    !isDeeplinkRoute && !isMobileHeader && (() => {
                        return (React.createElement(Box, { ref: globalSearchRef, className: `revamp-search-container${searchActive ? ' is-expanded' : ''}`, "data-tour-step": "app-list-search", sx: {
                                position: 'relative',
                                width: searchActive ? undefined : '250px',
                                maxWidth: searchActive ? undefined : '250px',
                                flexShrink: 1,
                                minWidth: '150px',
                                marginLeft: '16px',
                                transition: 'width 0.2s ease, max-width 0.2s ease',
                            } },
                            globalSearchOpen ? (React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', height: '36px', width: '100%' } },
                                React.createElement(Box, { sx: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        px: 1,
                                        height: '36px',
                                        width: '104px',
                                        flexShrink: 0,
                                        background: '#F2F2F3',
                                        border: '1px solid #000000',
                                        borderRadius: '8px 0 0 8px',
                                        cursor: 'pointer',
                                        userSelect: 'none',
                                        boxSizing: 'border-box',
                                    }, onClick: () => setGlobalSearchCategoryOpen((prev) => !prev), ref: categoryTriggerRef },
                                    React.createElement(Typography, { component: "p", className: "revamp-search-header-text", sx: { fontSize: '14px', color: '#3D3D42', fontWeight: 400, lineHeight: '20px', m: 0 } }, globalSearchActiveTab === 'dashboard'
                                        ? t('GLOBAL_SEARCH.Dashboard')
                                        : t('GLOBAL_SEARCH.All')),
                                    React.createElement(Box, { component: "svg", viewBox: "0 0 10 10", sx: { width: 10, height: 10, flexShrink: 0 } },
                                        React.createElement("path", { d: "M2 3.5l3 3 3-3", stroke: "#6E6E77", strokeWidth: "0.9375", fill: "none", strokeLinecap: "round", strokeLinejoin: "round" }))),
                                React.createElement(Box, { sx: {
                                        flex: 1,
                                        minWidth: 0,
                                        display: 'flex',
                                        alignItems: 'center',
                                        height: '36px',
                                        background: '#FFF',
                                        borderWidth: '1px 1px 1px 0',
                                        borderStyle: 'solid',
                                        borderColor: '#000000',
                                        borderRadius: '0 8px 8px 0',
                                        boxSizing: 'border-box',
                                        px: 1,
                                        gap: 1,
                                    } },
                                    React.createElement(Box, { sx: { flex: 1, minWidth: 0 } },
                                        React.createElement(AppHeaderSearch, { className: "revamp-search-header-text", value: globalSearchText, placeholder: globalSearchActiveTab === 'dashboard' ? t('GLOBAL_SEARCH.PlaceholderDashboard') : t('GLOBAL_SEARCH.PlaceholderAll'), onChange: (v) => setGlobalSearchText(v), showClear: false, matchCount: globalSearchText.length >= 3 ? searchResults.length : undefined, inputProps: {
                                                autoFocus: true,
                                                onKeyDown: (e) => {
                                                    if (e.key === 'Enter')
                                                        handleSearchNavigate();
                                                },
                                            }, sx: {
                                                width: '100%',
                                                background: 'transparent',
                                                fontSize: '14px',
                                                '& .MuiOutlinedInput-root': { background: 'transparent', px: 0 },
                                                '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
                                                '&:hover .MuiOutlinedInput-notchedOutline': { border: 'none' },
                                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': { border: 'none' },
                                            } })),
                                    React.createElement(IconButton, { size: "small", sx: { p: 0.5, flexShrink: 0, color: '#9CA3AF' }, onClick: () => {
                                            dispatch(globalSearch_actions.clearSearch());
                                            setGlobalSearchCategoryOpen(false);
                                        } },
                                        React.createElement(CloseIcon, { sx: { fontSize: 16 } }))))) : (globalDisplayText || globalSearchText) ? (React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', height: '36px', width: '100%' } },
                                React.createElement(Box, { sx: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        px: 1,
                                        height: '36px',
                                        width: '104px',
                                        flexShrink: 0,
                                        background: '#F2F2F3',
                                        border: '1px solid #000000',
                                        borderRadius: '8px 0 0 8px',
                                        cursor: 'pointer',
                                        userSelect: 'none',
                                        boxSizing: 'border-box',
                                    }, onClick: () => { setGlobalSearchOpen(true); setGlobalSearchCategoryOpen(true); } },
                                    React.createElement(Typography, { component: "p", className: "revamp-search-header-text", sx: { fontSize: '14px', color: '#3D3D42', fontWeight: 400, lineHeight: '20px', m: 0 } }, globalSearchActiveTab === 'dashboard' ? t('GLOBAL_SEARCH.Dashboard') : t('GLOBAL_SEARCH.All')),
                                    React.createElement(Box, { component: "svg", viewBox: "0 0 10 10", sx: { width: 10, height: 10, flexShrink: 0 } },
                                        React.createElement("path", { d: "M2 3.5l3 3 3-3", stroke: "#6E6E77", strokeWidth: "0.9375", fill: "none", strokeLinecap: "round", strokeLinejoin: "round" }))),
                                React.createElement(Box, { sx: {
                                        flex: 1,
                                        minWidth: 0,
                                        display: 'flex',
                                        alignItems: 'center',
                                        height: '36px',
                                        background: '#FFF',
                                        borderWidth: '1px 1px 1px 0',
                                        borderStyle: 'solid',
                                        borderColor: '#000000',
                                        borderRadius: '0 8px 8px 0',
                                        boxSizing: 'border-box',
                                        px: 1,
                                        gap: 1,
                                        cursor: 'pointer',
                                        '&:hover': { backgroundColor: '#F5F6F8' },
                                    }, onClick: () => setGlobalSearchOpen(true) },
                                    React.createElement(SearchIcon, { sx: { fontSize: 20, color: '#6E6E77', flexShrink: 0 } }),
                                    React.createElement(Typography, { className: "revamp-search-header-text", sx: {
                                            flex: 1,
                                            minWidth: 0,
                                            fontSize: '14px',
                                            color: '#3D3D42',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            userSelect: 'none',
                                        } }, globalDisplayText || globalSearchText),
                                    searchResults.length > 0 && !globalDisplayText && (React.createElement(Typography, { component: "span", sx: {
                                            fontSize: '11px',
                                            fontWeight: 600,
                                            lineHeight: '14px',
                                            color: 'var(--color)',
                                            whiteSpace: 'nowrap',
                                            px: 0.75,
                                            py: 0.25,
                                            borderRadius: '4px',
                                            backgroundColor: 'color-mix(in srgb, var(--color) 10%, transparent)',
                                            flexShrink: 0,
                                        } }, `${searchResults.length} ${searchResults.length === 1 ? t('GLOBAL_SEARCH.Match') : t('GLOBAL_SEARCH.Matches')}`)),
                                    React.createElement(IconButton, { size: "small", sx: { p: 0.5, flexShrink: 0, color: '#9CA3AF' }, onClick: (e) => {
                                            e.stopPropagation();
                                            dispatch(globalSearch_actions.clearSearch());
                                            setGlobalSearchCategoryOpen(false);
                                        } },
                                        React.createElement(CloseIcon, { sx: { fontSize: 16 } }))))) : (React.createElement(Box, { sx: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    width: '100%',
                                    height: '36px',
                                    background: '#FFF',
                                    border: '1px solid #A2A2A9',
                                    borderRadius: '8px',
                                    px: 1.5,
                                    gap: 1,
                                    cursor: 'pointer',
                                    boxSizing: 'border-box',
                                    '&:hover': { backgroundColor: '#F5F6F8' },
                                }, onClick: () => setGlobalSearchOpen(true) },
                                React.createElement(SearchIcon, { sx: { fontSize: 18, color: '#6E6E77', flexShrink: 0 } }),
                                React.createElement(Box, { component: "input", className: "revamp-search-header-text", placeholder: globalSearchActiveTab === 'dashboard' ? t('GLOBAL_SEARCH.PlaceholderDashboard') : t('GLOBAL_SEARCH.PlaceholderAll'), onFocus: () => setGlobalSearchOpen(true), sx: {
                                        flex: 1,
                                        border: 'none',
                                        outline: 'none',
                                        background: 'transparent',
                                        fontSize: '14px',
                                        color: '#3D3D42',
                                        '&::placeholder': { color: '#3D3D42' },
                                    } }))),
                            globalSearchOpen && globalSearchCategoryOpen && (React.createElement(Box, { ref: categoryDropdownRef, sx: {
                                    position: 'absolute',
                                    top: '44px',
                                    left: '7px',
                                    width: '135px',
                                    background: '#FFFFFF',
                                    border: '1px solid #D7D7DA',
                                    borderRadius: '4px',
                                    zIndex: 1202,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    p: '12px',
                                    gap: '10px',
                                    boxSizing: 'border-box',
                                } }, [
                                { key: 'all', label: t('GLOBAL_SEARCH.AllApplications') },
                                { key: 'dashboard', label: t('GLOBAL_SEARCH.Dashboard') },
                            ].map((item) => (React.createElement(Box, { key: item.key, onClick: () => {
                                    setGlobalSearchActiveTab(item.key);
                                    setGlobalSearchCategoryOpen(false);
                                }, sx: {
                                    cursor: 'pointer',
                                    whiteSpace: 'nowrap',
                                } },
                                React.createElement("p", { style: { margin: 0, fontSize: '16px', fontWeight: 400, lineHeight: '19px', color: globalSearchActiveTab === item.key ? '#000000' : '#A2A2A9', fontFamily: 'var(--font-family)' } }, item.label)))))),
                            globalSearchText.length >= 3 && globalSearchOpen && (React.createElement(Box, { sx: {
                                    position: 'absolute',
                                    top: 'calc(100% + 4px)',
                                    left: 0,
                                    width: '100%',
                                    background: '#FFFFFF',
                                    borderRadius: '8px',
                                    border: '1px solid #E8E8EC',
                                    boxShadow: '0px 4px 16px rgba(0,0,0,0.08)',
                                    zIndex: 1200,
                                    overflow: 'hidden',
                                    pt: '16px',
                                    pb: 0,
                                } },
                                React.createElement(Typography, { sx: { fontSize: '16px', fontWeight: 600, color: '#A2A2A9', lineHeight: '19px', px: 2, pb: 1 } }, globalSearchActiveTab === 'dashboard'
                                    ? t('GLOBAL_SEARCH.Dashboard')
                                    : t('GLOBAL_SEARCH.AllApplications')),
                                React.createElement(Box, { sx: { maxHeight: '360px', overflowY: 'auto' } }, searchResults.length === 0 ? (React.createElement(Box, { sx: { px: 2, textAlign: 'center', py: 2.5 } },
                                    React.createElement(Typography, { sx: { fontSize: '14px', color: '#A2A2A9' } }, globalSearchText.length >= 3 ? t('GLOBAL_SEARCH.NoResults') : ''))) : (searchResults.map((result, idx) => (React.createElement(Box, { key: idx },
                                    React.createElement(Box, { onClick: () => handleResultClick(result), sx: {
                                            display: 'flex',
                                            flexDirection: 'column',
                                            px: 2,
                                            pt: '4px',
                                            pb: '4px',
                                            gap: '4px',
                                            minHeight: '60px',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                            '&:hover': { background: '#F9FAFB' },
                                            '& *': { pointerEvents: 'none' },
                                        } },
                                        React.createElement(Typography, { sx: { fontSize: '14px', fontWeight: 400, color: '#000000', lineHeight: '20px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } }, result.Name),
                                        React.createElement(Box, { sx: { display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', rowGap: 0.5 } },
                                            React.createElement(Box, { sx: { display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1.5, rowGap: 0.25, minWidth: 0 } },
                                                React.createElement(Typography, { sx: { fontSize: '14px', fontWeight: 400, color: '#6E6E77', lineHeight: '16px', whiteSpace: 'nowrap' } },
                                                    'Contract ID: ',
                                                    React.createElement(Typography, { component: "span", sx: { fontSize: '14px', fontWeight: 600, color: '#6E6E77', lineHeight: '16px' } }, result.ContractAspireId || result.ContractAspireRecordId || '--'))),
                                            React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 } },
                                                React.createElement(Typography, { sx: { fontSize: '12px', fontWeight: 400, color: '#A2A2A9', lineHeight: '14px', whiteSpace: 'nowrap' } },
                                                    t('GLOBAL_SEARCH.Status'),
                                                    ' : ',
                                                    React.createElement(Box, { component: "span", sx: { fontWeight: 500, color: '#6E6E77' } }, getResultDisplayStatus(result))),
                                                React.createElement(Box, { sx: { width: 20, height: 20, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' } }, getResultStatusIcon(result))))),
                                    React.createElement(Divider, { sx: { borderColor: '#BDBDC2' } }))))))))));
                    })(),
                    React.createElement(Box, { className: 'revamp-header-right', ref: headerRightRef },
                        isMobileHeader && !isDeeplinkRoute && !mobileSearchOpen && (React.createElement(IconButton, { className: "revamp-bell-wrap", sx: { color: '#6B7280' }, onClick: () => {
                                setMobileSearchOpen(true);
                                setGlobalSearchOpen(true);
                                setGlobalSearchActiveTab('all');
                            } },
                            React.createElement(SearchIcon, { sx: { fontSize: 22 } }))),
                        React.createElement(Box, { sx: { display: { xs: 'none', md: 'contents' } } },
                            React.createElement(Button, { className: 'revamp-lang-btn', disableRipple: true, onClick: openLanguageMenu },
                                React.createElement(GlobeDesignIcon, null),
                                React.createElement(Typography, { fontSize: '14px', fontWeight: '400' }, (selectedLangCode || Language.ENGLISH).toUpperCase()),
                                React.createElement(ChevronDownDesignIcon, null))),
                        React.createElement(Menu, { anchorEl: langMenuAnchorEl, open: isLangMenuOpen, onClose: closeLanguageMenu, className: 'revamp-lang-menu' }, LanguageOptions.map((langItem) => (React.createElement(MenuItem, { key: langItem.value, selected: selectedLangCode === langItem.value, onClick: () => handleLanguageSelect(langItem.value) }, langItem.lang)))),
                        !isDeeplinkRoute && (React.createElement(React.Fragment, null,
                            React.createElement(IconButton, { className: 'revamp-bell-wrap', onClick: openNotificationsPopup },
                                React.createElement(NotificationDesignIcon, null)),
                            React.createElement(Box, { sx: { display: { xs: 'none', md: 'contents' } } },
                                React.createElement(Box, { className: 'revamp-user-info' },
                                    React.createElement(Tooltip, { title: userName, placement: "bottom", disableHoverListener: !userName, arrow: true },
                                        React.createElement(Typography, { className: 'name' }, userName)),
                                    React.createElement(Typography, { className: 'role' }, userRoleLabel)),
                                React.createElement(IconButton, { className: 'revamp-profile-trigger', onClick: openProfileMenu },
                                    React.createElement(ProfilePictureIcon, null))))))))),
        !isDeeplinkRoute && isProfileMenuOpen && (React.createElement(React.Fragment, null,
            React.createElement(Box, { className: 'revamp-profile-overlay', onClick: closeProfileMenu }),
            React.createElement(Box, { className: 'revamp-profile-menu-panel' },
                React.createElement(Box, { className: 'revamp-profile-menu-user' },
                    React.createElement(Tooltip, { title: userName, placement: "top", disableHoverListener: !userName, arrow: true },
                        React.createElement(Typography, { className: 'name' }, userName)),
                    React.createElement(Typography, { className: 'role' }, userRoleLabel)),
                React.createElement(Box, { className: 'revamp-profile-menu-row' },
                    React.createElement(MailOutlineIcon, { className: 'item-icon' }),
                    React.createElement(Tooltip, { title: userEmail, placement: "top", disableHoverListener: !userEmail, arrow: true },
                        React.createElement(Typography, { className: 'item-text' }, userEmail))),
                React.createElement(Box, { className: 'revamp-profile-menu-row clickable', onClick: () => {
                        closeProfileMenu();
                        setOpenLogoutConfirm(true);
                    } },
                    React.createElement(LogoutIcon, { className: 'item-icon' }),
                    React.createElement(Typography, { className: 'item-text' }, t('HEADER.sign_out')))))),
        React.createElement(Menu, { anchorEl: moreMenuAnchorEl, open: Boolean(moreMenuAnchorEl), onClose: closeMoreMenu, TransitionProps: {
                onExited: () => {
                    const action = pendingMoreMenuActionRef.current;
                    pendingMoreMenuActionRef.current = null;
                    action === null || action === void 0 ? void 0 : action();
                },
            }, className: 'revamp-more-menu', anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'left' }, disableAutoFocusItem: true },
            (() => {
                if (visibleTabKeys === null)
                    return null;
                const activeHeaderTab = getActiveHeaderTab();
                const collapsedTabConfig = [
                    { key: 'dashboard', icon: React.createElement(DashboardNavIcon, { isActive: false }), label: t('DASHBOARD_HEADER.DASHBOARD') },
                    { key: 'applications', icon: React.createElement(ApplicationsNavIcon, { isActive: false }), label: t('DASHBOARD_HEADER.ALL_APPLICATIONS') },
                    { key: 'quoteTool', icon: React.createElement(QuoteToolNavIcon, { isActive: false }), label: t('DASHBOARD_HEADER.QUOTE_TOOL') },
                    { key: 'sentApplications', icon: React.createElement(SentApplicationsNavIcon, { isActive: false }), label: t('DASHBOARD_HEADER.SENT_APPLICATIONS') },
                ];
                const visibleCollapsed = collapsedTabConfig.filter(item => {
                    if (item.key === activeHeaderTab)
                        return false;
                    if (visibleTabKeys.has(item.key))
                        return false;
                    const tabDef = headerTabs.find(t => t.key === item.key);
                    return !(tabDef === null || tabDef === void 0 ? void 0 : tabDef.hidden);
                });
                if (visibleCollapsed.length === 0)
                    return null;
                return (React.createElement(React.Fragment, null, visibleCollapsed.map(item => (React.createElement(MenuItem, { key: item.key, className: 'revamp-more-menu-item', onClick: () => runAfterMoreMenuCloses(() => handleHeaderTabClick(item.key)) },
                    React.createElement(Box, { className: 'more-menu-icon-wrap' }, item.icon),
                    React.createElement(Typography, null, item.label))))));
            })(),
            (!(vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.IsAnalyticsEnabled) || ((_g = userBasicInfo === null || userBasicInfo === void 0 ? void 0 : userBasicInfo.userData) === null || _g === void 0 ? void 0 : _g.RoleType) === constants.roleTypes.CUSTOMER_HQMANAGER) ? null : (React.createElement(MenuItem, { className: 'revamp-more-menu-item', onClick: () => handleMoreItemClick('analytics') },
                React.createElement(Box, { className: 'more-menu-icon-wrap' },
                    React.createElement(AnalyticsIcon, null)),
                React.createElement(Typography, null, t('Dashboard.SideMenuOptions.Analytics')))),
            (vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.RateCardUrl) ? (React.createElement(MenuItem, { className: 'revamp-more-menu-item', onClick: () => handleMoreItemClick('rateCard') },
                React.createElement(Box, { className: 'more-menu-icon-wrap' },
                    React.createElement(RateCard, null)),
                React.createElement(Typography, null, t('Dashboard.SideMenuOptions.Rate Card')))) : null,
            (vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.FAQUrl) ? (React.createElement(MenuItem, { className: 'revamp-more-menu-item', onClick: () => handleMoreItemClick('faq') },
                React.createElement(Box, { className: 'more-menu-icon-wrap' },
                    React.createElement(FAQIcon, null)),
                React.createElement(Typography, null, t('Dashboard.SideMenuOptions.FAQ')))) : null,
            React.createElement(MenuItem, { className: 'revamp-more-menu-item', onClick: () => handleMoreItemClick('needHelp') },
                React.createElement(Box, { className: 'more-menu-icon-wrap' },
                    React.createElement(SupportIcon, null)),
                React.createElement(Typography, null, t('NeedHelp.Heading')))),
        React.createElement(NeedHelpDialog, { open: openNeedhelp, onClose: () => setNeedhelp(false), supportEmail: (_j = (_h = vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.HelpEmail) !== null && _h !== void 0 ? _h : helpMail) !== null && _j !== void 0 ? _j : process.env.NEED_HELP_SUPPORT_EMAIL }),
        React.createElement(Popover, { open: isNotificationsOpen, anchorEl: notificationsAnchorEl, onClose: closeNotificationsPopup, className: 'revamp-notifications-popover', anchorOrigin: { vertical: 'bottom', horizontal: 'right' }, transformOrigin: { vertical: 'top', horizontal: 'right' }, slotProps: {
                paper: {
                    className: 'revamp-notifications-paper',
                },
            } },
            React.createElement(Box, { className: 'revamp-notifications-header' },
                React.createElement(Typography, { className: 'title' }, t('DASHBOARD_HEADER.NOTIFICATIONS')),
                React.createElement(IconButton, { className: 'close-btn', onClick: closeNotificationsPopup },
                    React.createElement(CloseOutlinedIcon, { sx: { fontSize: 22 } }))),
            React.createElement(Box, { className: 'revamp-notifications-subheader' },
                React.createElement(Typography, { className: 'subheader-title' }, t('DASHBOARD_HEADER.ANNOUNCEMENTS_UPDATES', { defaultValue: 'Announcements and Updates' }))),
            React.createElement(Box, { className: 'revamp-notifications-content' },
                React.createElement(Box, { className: 'revamp-announcement-list' }, announcementItems.length === 0 ? (React.createElement(Box, { className: 'revamp-announcement-card revamp-announcement-empty' },
                    React.createElement(Typography, { className: 'announcement-title' }, t('DASHBOARD_HEADER.NO_ANNOUNCEMENTS', { defaultValue: 'No Announcements' })))) : (announcementItems.map((announcementItem) => (React.createElement(Box, { key: announcementItem.id, className: 'revamp-announcement-card' },
                    React.createElement(Typography, { className: 'announcement-description' }, announcementItem.description),
                    React.createElement(Box, { className: 'announcement-footer' },
                        React.createElement(Typography, { className: 'announcement-time' }, announcementItem.timestamp))))))))),
        React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.UNSAVED_DATA_WARNING, titleText: isExitScenario
                ? t('GENERIC_STRINGS.UNSAVED_ALERT.title_exit')
                : isApplicationFormRoute
                    ? t('GENERIC_STRINGS.UNSAVED_ALERT.title')
                    : t('GENERIC_STRINGS.DeleteConfirmationPopups.AreYouSureLabel'), message: isExitScenario
                ? t('GENERIC_STRINGS.UNSAVED_ALERT.warning_msg_exit')
                : isApplicationFormRoute
                    ? t('GENERIC_STRINGS.UNSAVED_ALERT.warning_msg')
                    : isCurrentFormDirty ? t('GENERIC_STRINGS.UNSAVED_ALERT.msgDiscard') : t('GENERIC_STRINGS.UNSAVED_ALERT.msgLeave'), acceptBtnText: isExitScenario
                ? t('GENERIC_STRINGS.CommonButtons.Yes')
                : isCurrentFormDirty || isApplicationFormRoute ? t('GENERIC_STRINGS.CommonButtons.Discard') : t('GENERIC_STRINGS.CommonButtons.Yes'), denyBtnText: isExitScenario
                ? t('GENERIC_STRINGS.CommonButtons.No')
                : isCurrentFormDirty || isApplicationFormRoute ? t('GENERIC_STRINGS.CommonButtons.Cancel') : t('GENERIC_STRINGS.CommonButtons.No'), acceptCallBack: confirmGuardedNavigation, denyCallBack: closeGuardedNavigationPopup, open: openQuoteToolUnsavedPopup, key: `${openQuoteToolUnsavedPopup}`, cancelCallBack: closeGuardedNavigationPopup }),
        React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.LOGOUT_WARNING, titleText: t('GENERIC_STRINGS.LOGOUT_WARNING.title'), message: t('GENERIC_STRINGS.LOGOUT_WARNING.msg'), acceptBtnText: t('GENERIC_STRINGS.LOGOUT_WARNING.accept_btn'), denyBtnText: t('GENERIC_STRINGS.LOGOUT_WARNING.deny_btn'), acceptCallBack: React.useCallback(() => {
                logout();
                setOpenLogoutConfirm(false);
            }, [openLogoutConfirm]), denyCallBack: React.useCallback(() => {
                setOpenLogoutConfirm(false);
            }, []), open: openLogoutConfirm, key: `logout-${openLogoutConfirm}`, cancelCallBack: React.useCallback(() => {
                setOpenLogoutConfirm(false);
            }, []) }),
        !isDeeplinkRoute && (React.createElement(Drawer, { anchor: 'left', open: state.left, onClose: toggleDrawer('left', false) }, list('left'))),
        React.createElement(Box, { className: 'revamp-appbar-spacer' }),
        showSuperUserBanner && (React.createElement(Box, { className: 'revamp-super-user-banner', role: 'status', ref: superUserBannerRef },
            React.createElement(Box, { className: 'revamp-super-user-pill' },
                React.createElement(AccessTimeOutlinedIcon, { sx: { fontSize: 16, color: '#6B7280', flexShrink: 0 } }),
                React.createElement(Typography, { className: 'revamp-super-user-text' }, t('GENERIC_STRINGS.SuperUserBannerMsg')),
                React.createElement(CountdownTimer, { startTimeString: impersonationDetails === null || impersonationDetails === void 0 ? void 0 : impersonationDetails.SessionStartTime, handleLogout: logout, timerColor: '#2E75B6' })))),
        isRevampDashboardHeader && (React.createElement(MarketingBanner, { ref: marketingBannerRef, marketingBannerItems: marketingBannerItems, isSuperUser: isSuperUser, impersonationDetails: impersonationDetails, handleSuperUserLogout: logout }))));
}
